module.exports = __webpack_public_path__ + "static/media/Tasting Notes_gradient.75d5d2f9.png";